import type { ReactNode } from 'react';
import useFetchPermission from '../../../../utilities/customHooks/useFetchPermission';
import ErrorScreen from '../ErrorScreen';

interface ProtectedComponentProps {
  permission: string;
  children: ReactNode;
  fallback?: ReactNode;
}

const ProtectedComponent = ({ permission, children, fallback = null }: ProtectedComponentProps) => {
  if (!permission) {
    return <>{children}</>;
  }
  const { isAuthorized, isLoading, isError, error } = useFetchPermission(permission);

  if (isLoading) {
    return;
  }

  if (isError) {
    return <ErrorScreen message={error?.message} />;
  }

  return isAuthorized ? <>{children}</> : <>{fallback}</>;
};

export default ProtectedComponent;
